// extracted by mini-css-extract-plugin
export default {"wrapper":"aP8JXjA0spovliIhL4RW"};